import { addEvent, removeEvent, Throttle } from '../utils/events';
import { addClasses, setStyles, hasClass } from '../utils/html';
const TIMEOUT_ALERT_RESIZE_INTERVAL = 10;
export class Alert {

  /**
   * @param  {Dom}    alert             container to hold modal
   * @param  {String} closeClickArea    click area for close button
   */
  constructor(alert, closeClickArea, autoCloseTime, isInline, minimisedCellIndex) {
    this.alert = alert;

    if (!this.isEverythingOk()) {
      return;
    }

    this.closeClickArea = alert.querySelector(closeClickArea);
    this.autoCloseTime = autoCloseTime;
    this.open = true;
    this.isInline = isInline;
    this.minimisedCellIndex = minimisedCellIndex;
    if (this.isInline) {
      this.alertOverlay = alert.querySelector('.js-alert-overlay');
    }
    // Initialize alert
    this.init();
  }

  init() {
    if (this.closeClickArea) {
      addEvent(this.closeClickArea, 'click', this.close.bind(this));
      addClasses(this.alert, [ 'is-closeable' ]);
    }
    if (this.autoCloseTime) {
      setTimeout(() => {
        if (this.open) {
          this.close();
        }
      }, this.autoCloseTime);
    }
  }

  close() {
    if (this.isInline) {
      if (this.minimisedCellIndex && hasClass(this.alertOverlay, 'js-pending-alert')) {
        this.minimiseInlineAlert();
      } else {
        addClasses(this.alertOverlay, [ 'hide' ]);
        this.open = false;
      }
    } else if (this.open) {
      if (this.closeClickArea) {
        removeEvent(this.closeClickArea, 'click', this.close.bind(this));
      }
      this.alert.outerHTML = '';
      this.open = false;
    }
  }

  minimiseInlineAlert() {
    if (this.minimisedCellIndex) {
      addClasses(this.alertOverlay, [ 'is-minimised' ]);
      const targettedCell = this.alert.cells[this.minimisedCellIndex];
      const rightPos = this.alert.offsetWidth - (targettedCell.offsetLeft + targettedCell.offsetWidth);
      setStyles(this.alertOverlay, {
        'left': `${ (targettedCell.offsetLeft) }px`,
        'right': `${ rightPos }px`,
      });
      this.windowResizeListener = () => {
        const updatedRightPos = this.alert.offsetWidth - (targettedCell.offsetLeft + targettedCell.offsetWidth);
        setStyles(this.alertOverlay, {
          'left': `${ (targettedCell.offsetLeft) }px`,
          'right': `${ updatedRightPos }px`,
        });
      };
      this.windowResize = new Throttle(this.windowResizeListener, TIMEOUT_ALERT_RESIZE_INTERVAL);
      addEvent(window, 'resize', this.windowResize.trigger);
    }
    this.open = false;
    if (this.closeClickArea) {
      removeEvent(this.closeClickArea, 'click', this.close.bind(this));
    }
  }

  destroy() {
    this.close();
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.alert) {
      console.warn('CommonUI - Alert - There\'s no alert found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * Creates a new alert instance
 * @param  {Object} config
 */
export default function initAlert(config = {}) {
  const { selector = '.js-alert', closeSelector = '.js-alert__close', autoCloseTime = null,
    inline = false, minimisedCellIndex = null } = config;
  let alerts = null;
  if (typeof selector === 'string') {
    for (const alert of document.querySelectorAll(selector)) {
      alerts = new Alert(alert, closeSelector, autoCloseTime, inline, minimisedCellIndex);
    }
  }
  return alerts;
}



// WEBPACK FOOTER //
// ./js/components/Alert.js